import { FC } from 'react'
import PointsOfInterestComponent from 'components/PointsOfInterest'
import { getPointsOfInterest } from 'lib/pointsOfInterest'
import { PointOfInterest } from 'graphql/types'
import { TLocation } from 'pages/regioes-atendidas/regiao/types'
import { collapsePoisClickEvent } from 'pages/regioes-atendidas/regiao/events'

export type TProps = {
  locationType: TLocation
  pointsOfInterest: Array<PointOfInterest>
}

const PointsOfInterest: FC<TProps> = ({ locationType, pointsOfInterest }) => {
  if (!pointsOfInterest?.length) return null

  const points = getPointsOfInterest({
    type: locationType,
    pointOfInterest: pointsOfInterest,
  })

  return (
    <PointsOfInterestComponent
      items={points}
      title="Pontos de Interesse"
      text="Conheça os principais pontos da região e veja imóveis próximos à venda"
      onClickCollapse={(isExpanded: boolean) =>
        collapsePoisClickEvent({
          locationType,
          label: isExpanded ? 'Ver menos' : 'Ver mais',
        })
      }
    />
  )
}

export default PointsOfInterest
